export class UserProDataSetProperty {
    id: number = 0;
    propertyName: string = '';
    isSelected: boolean = false;
    isRestricted: boolean = false;

    static mapProperties(item: any): UserProDataSetProperty {
        return {
            id: item.id,
            propertyName: item.property_name,
            isSelected: item.is_selected,
            isRestricted: item.is_restricted
        }

    }
}
